// extracted by mini-css-extract-plugin
export default {"component":"Loader__component--lc-c560i","loader":"Loader__loader--lc-e1wa4","preloader":"Loader__preloader--lc-c7koa"};